<template>
  <b-button class="button button-primary generic-button" :href="href">{{ text }}</b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'
export default {
  components: { BButton },
  props: {
    href: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.generic-button {
  justify-content: center;
  width: 250px;
}
</style>
